export const convertHKPrice = (price: number) => {
  const formattedNumber = price.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return 'HK' + formattedNumber;
};
